module.exports = __webpack_public_path__ + "static/media/comp-screening-s.60741927.webp";